var AWS = require('aws-sdk');
var ProgressBar = require('progressbar.js');

function init() {
	innerInit();
	new MutationObserver(function() {innerInit();}).observe(document, {childList: true, subtree: true});
}

function innerInit() {
	var uploadEl = document.querySelector('.fileUpload:not(.fileUpload--setUp)');
	if (!uploadEl)
		return;
	uploadEl.classList.add('fileUpload--setUp');

	var maxSize = 25000000;
	var maxTotalSize = 25000000;

	var bucketName = 'edcoproductsfileupload';
	var bucketRegion = 'us-east-2' ;
	var IdentityPoolId = 'us-east-2:b3567800-4e06-48d3-95fb-da33e9b0076c';

	var folderKey = 'files/';

	AWS.config.update({
		region: bucketRegion,
		credentials: new AWS.CognitoIdentityCredentials({
			IdentityPoolId: IdentityPoolId
		})
	});

	var s3 = new AWS.S3({
		apiVersion: '2006-03-01',
		params: { Bucket: bucketName }
	});

	var fileMessageEl = uploadEl.getElementsByClassName('fileUpload__messages')[0];
	var hiddenInputEl = uploadEl.getElementsByClassName('fileUploadHidden')[0];

	initFileInput();
	initDropFileInput();

	function createUploadFunction(file, fileKey, listEl, hiddenInputEl, paraEl) {
		return function() {
			var listItemElAbstr = document.createElement('li');
			listItemElAbstr.classList.add('loading');
			listItemElAbstr.innerHTML = decodeURIComponent(file.name) + '<span class="separator">,</span>';
			var listItemEl = listEl.appendChild(listItemElAbstr);
			var progressBar = new ProgressBar.Line(listItemEl, {
				color: '#c6202c',
				strokeWidth: 2,
				duration: 300
			});

			s3.upload({
				Key: fileKey,
				Body: file,
				ACL: 'public-read'
			}).on('httpUploadProgress', function(event) {
				var progress = event.loaded / event.total;
				progressBar.animate(progress);
			}).send(function (err, data) {

				if (err) {
					return alert('There was an error uploading your file: ', err.message);
				} else {
					paraEl.textContent = 'Files Uploaded: ';
					listItemEl.classList.remove('loading');
					listItemEl.classList.add('done');
					hiddenInputEl.value += data.Location + '\n';
					hiddenInputEl.dispatchEvent(new Event('change'));
				}
			});
		}
	}

	/**
	 * Loop through files and init S3 uploader
	 * @param {FileList} fileList The files to be uploaded
	 */
	function uploadFiles(fileList) {
		if (fileList.length) {
			// Reset messages
			while (fileMessageEl.firstChild) {
				fileMessageEl.removeChild(fileMessageEl.firstChild);
			}
			fileMessageEl.classList.remove('fileUpload--error');

			var paraEl = fileMessageEl.appendChild(document.createElement('p'));
			var listEl = fileMessageEl.appendChild(document.createElement('ol'));

			var totalSize = 0;
			var problemFiles = [];
			for (var i = 0; i < fileList.length; i++) {
				var file = fileList[i];

				totalSize += file.size;
				if (file.size > maxSize) {
					problemFiles.push(file);
				}
			}

			if (problemFiles.length || totalSize > maxTotalSize) {
				paraEl.textContent = 'Error: ';
				fileMessageEl.classList.add('fileUpload--error');

				var listItemEl = document.createElement('li');
				listItemEl.innerHTML = 'Files exceed maximum uploadable size (<strong>' + readableMb(totalSize) + '</strong>/' + readableMb(maxTotalSize) + ') <span class="separator">,</span>';
				listEl.appendChild(listItemEl);

				for (var i = 0; i < problemFiles.length; i++) {
					var file = fileList[i];
					var listItemEl = document.createElement('li');
					listItemEl.innerHTML = decodeURIComponent(file.name) + '(' + readableMb(file.size) + ') exceeds maximum file size <span class="separator">,</span>';
					listEl.appendChild(listItemEl);
				}
				return;
			}

			paraEl.textContent = 'Files Uploading: ';
			for (var i = 0; i < fileList.length; i++) {
				var file = fileList[i];

				var fileKey = folderKey + Date.now() + '-' + file.name;

				createUploadFunction(file, fileKey, listEl, hiddenInputEl, paraEl)();
			}
		}
	}

	/** Init input[type=text] */
	function initFileInput() {
		var inputEl = document.getElementById('fileUploadInput');
		if (!inputEl)
			return;

		inputEl.addEventListener('change', fileInputHandler);

		function fileInputHandler(event) {
			uploadFiles(inputEl.files);
		}
	}

	/** Upload from draggable zone */
	function initDropFileInput() {
		var dropEl = uploadEl.getElementsByClassName('drop-zone')[0];
		if (!dropEl)
			return;

		dropEl.addEventListener('dragover', dragoverHandler);
		dropEl.addEventListener('drop', dropHandler);
		dropEl.addEventListener('dragleave', dragendHandler);

		function dragoverHandler(event) {
			event.preventDefault();
			event.currentTarget.classList.add('drag');
		}

		function dropHandler(event) {
			event.preventDefault();
			uploadFiles(event.dataTransfer.files);
			event.currentTarget.classList.remove('drag');
		}

		function dragendHandler(event) {
			event.currentTarget.classList.remove('drag');
		}
	}
}

/**
 * Convert a files size in bytes to Mb
 * @param {number} size Size to convert
 */
function readableMb(size) {
	return size / 1000000 + 'Mb';
}

module.exports = {
	init: init
}
